import { ready } from '~/core';

ready('video', '.video-mediaThumb', trigger => {
	const container = trigger.closest('.video')
	const media = container.querySelector('.video-media')
	const frame = media.querySelector('iframe');
	const video = media.querySelector('.video-mediaVideo')

	function triggerModal() {
		frame.setAttribute('src', frame.getAttribute('src'))
		setTimeout(() => {
			media.classList.toggle('video-open')
			window.location.hash = trigger.dataset.hash
		}, 250)
	}

	function closeModal() {
		frame.setAttribute('src', frame.getAttribute('src'))
		setTimeout(() => {
			media.classList.toggle('video-open')
			removeHash()
		}, 250)
	}

	function removeHash() { 
    history.pushState("", document.title, window.location.pathname + window.location.search);
	}
	
	window.addEventListener('DOMContentLoaded', (e) => {
		if(window.location.hash) {
			e.stopImmediatePropagation();
			let videoHash = document.querySelector(`[data-hash=${window.location.hash.substr(1)}]`)
			let current = videoHash.closest('.video-media')
			current.classList.add('video-open')
		}
	})

	trigger.addEventListener('click', triggerModal);
	video.addEventListener('click', closeModal)
});